import Layout from '@components/Items/Filters/Layout'
import useFilter from '@components/Items/utils/hooks/useFilter'
import { FC } from 'react'
import { QUERY_KEYS } from '@components/Items/utils/functions'
import _isArray from 'lodash/isArray'
import Checkbox from '@components/Items/components/checkbox'

const EndDates = () => {
  const { endDateList } = useFilter()
  return (
    <Layout label={'END DATE'}>
      <fieldset>
        <legend className="sr-only">End Dates</legend>
        <div className="space-y-1">
          {endDateList.map((endDate) => (
            <EndDate endDate={endDate} key={`end-date-${endDate}`} />
          ))}
        </div>
      </fieldset>
    </Layout>
  )
}

const EndDate: FC<{ endDate: string }> = ({ endDate }) => {
  const { updateQuery, endDateQuery } = useFilter()

  const handleChange = async () => {
    await updateQuery(QUERY_KEYS.END_DATE, endDate, true)
  }

  const isChecked = endDateQuery
    ? _isArray(endDateQuery)
      ? endDateQuery.includes(endDate)
      : endDateQuery === endDate
    : false

  return (
    <Checkbox checked={isChecked} onChange={handleChange}>
      {endDate}
    </Checkbox>
  )
}

export default EndDates
